import { render, staticRenderFns } from "./TireScroll.vue?vue&type=template&id=50ea8017&scoped=true&"
var script = {}
import style0 from "./TireScroll.vue?vue&type=style&index=0&id=50ea8017&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ea8017",
  null
  
)

export default component.exports